import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

function TooltipIcon({ message }: { message: string }) {
  return (
    <div
      className='tooltip tooltip-success tooltip-right tooltip-icon'
      data-tip={message}
    >
      <FontAwesomeIcon icon={faCircleInfo} className='ml-1' />
    </div>
  );
}

export default TooltipIcon;
